// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2cehu","containerItemsCenter":"Skeleton_containerItemsCenter__3FK_5"};